import React, { useState } from "react";
import background from "../assets/images/background.png";
import backgroundImg from "../assets/images/background-2.jpg";
import origami1 from "../assets/images/origami.png";
import origami2 from "../assets/images/origam.png";
import Footer from "../components/Footer";
import uploadIcon from "../assets/icons/svg/upload.svg";
import FormHeader from "../components/FormHeader";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

import DataPostService from "../domain/services/data-post-service";
import useStepper from "../utils/useStepper";
import { DataGetService } from "../domain";
import { useEffect } from "react";
import Preloader from "../components/Preloader";

import FileUploadService from "../domain/services/file-upload";

const Survey = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { currentStep, totalSteps, nextStep, prevStep } = useStepper(2);
  const [isUnibanker, setIsUnibanker] = useState(null);
  const [files, setFiles] = useState([]);
  const [surveyResponse, setSurveyResponse] = useState([]);
  const [email, setEmail] = useState("");
  const [emailEntered, setEmailEntered] = useState(false);

  const isEmailValid = email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const MIME_TYPES = {
    pdf: { mime: "application/pdf", signatures: ["25 50 44 46"] }, 
    png: { mime: "image/png", signatures: ["89 50 4E 47"] },
    jpg: { mime: "image/jpeg", signatures: ["FF D8 FF DB", "FF D8 FF E0", "FF D8 FF EE"] },
    jpeg: { mime: "image/jpeg", signatures: ["FF D8 FF DB", "FF D8 FF E0", "FF D8 FF EE"] },
  };
  
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const MAX_FILES = 5;
  
  const getFileSignature = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = (event) => {
        if (event.target.readyState === FileReader.DONE) {
          const uintArray = new Uint8Array(event.target.result).slice(0, 4);
          const hexSignature = Array.from(uintArray).map(b => b.toString(16).toUpperCase().padStart(2, "0")).join(" ");
          resolve(hexSignature);
        }
      };
      reader.onerror = () => reject("Error reading file");
      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  };
  
  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    const validFiles = [];
    let errorMessage = "";
  
    for (const file of selectedFiles) {
      const mimeType = Object.values(MIME_TYPES).find((type) => type.mime === file.type);
      const isValidSize = file.size <= MAX_FILE_SIZE;
      const isDuplicate = files.some((existingFile) => existingFile.name === file.name);
  
      if (!mimeType) {
        errorMessage += `${file.name} is not a supported file type.\n`;
        continue;
      }
  
      const fileSignature = await getFileSignature(file);
  
      if (!mimeType.signatures.includes(fileSignature)) {
        errorMessage += `${file.name} is not valid, Please upload a valid file.\n`;
        continue;
      }
  
      if (!isValidSize) {
        errorMessage += `${file.name} exceeds the 10MB size limit.\n`;
        continue;
      }
  
      if (isDuplicate) {
        errorMessage += `${file.name} is already uploaded.\n`;
        continue;
      }
  
      validFiles.push(file);
    }
  
    if (errorMessage) {
      setErrors((prevErrors) => ({ ...prevErrors, files: errorMessage }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, files: "" }));
    }
  
    setFiles((prevFiles) => [...prevFiles, ...validFiles].slice(0, MAX_FILES));
  };
  

  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  const [formData, setFormData] = useState({
    agreement: "",
    email: "",
    firstName: "",
    lastName: "",
    unibanker: "",
    branch: "",
    referrer: "",
    mobileNumber: "",
  });
  const [errors, setErrors] = useState({});

  const _DataGetService = new DataGetService();
  const [questions, setQuestions] = useState([]);
  const [choices, setChoices] = useState([]);
  const [survey, setSurvey] = useState([]);
  const [formSuccessData, setFormSuccessData] = useState(null);

  const dataGetServiceExecute = async () => {
    const response = await _DataGetService.execute({
      tables: ["surveyType", "questionType", "questionChoicesType"],
    });
    // console.log("qwerty", response);
    if (response?.data?.questionType) {
      setQuestions(response.data.questionType);
      setChoices(response.data.questionChoicesType || []);
      setSurvey(response.data.surveyType || []);
    }
    console.log("Fetched questions:", response.data.questionType);
  };

  useEffect(() => {
    dataGetServiceExecute();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const step1Valid = validateStep1();
    const step2Valid = validateStep2();
  
    if (step1Valid && step2Valid) {
      console.log("Validation passed!");
  
      const userResponse = {
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        bpiEmp: formData.unibanker,
        branch: formData.branch,
        referralName: formData.referrer,
        mobileNo: formData.mobileNumber,
      };
  
      const surveyResponses = questions.map((question, index) => {
        const surveyId = question.surveyId;
        const rawAnswerValue = formData[`question-${index}-options`] || [];
        const joinedAnswerValue = Array.isArray(rawAnswerValue)
          ? rawAnswerValue.join(", ")
          : rawAnswerValue;
  
        return {
          surveyId: surveyId,
          questionId: question.questionId,
          answerValue: joinedAnswerValue,
        };
      });
  
      const payload = {
        pseudoCustomer: userResponse,
        answers: surveyResponses,
        attachments: files.map(file => file.name),
      };
  
      try {
        const result = await DataPostService(JSON.stringify(payload));
        const { message, data } = result;
        const presignedUrlsFromData = data?.presignedUrls || [];

  
        if (presignedUrlsFromData.length > 0 && files.length > 0) {
          try {
  
            const uploadPromises = presignedUrlsFromData.map((url, index) => {
              return FileUploadService(url, files[index]);
            });
  
            const uploadResponses = await Promise.all(uploadPromises);
  
            const allUploadsSuccessful = uploadResponses.every(response => {
              return response.ok;
            });
  
            if (allUploadsSuccessful) {
              setFormSuccessData(result);
              navigate("/success");
              window.scrollTo(0, 0);
            } else {
              setErrors({ api: "Failed to upload files. Please try again." });
            }
          } catch (uploadError) {
            setErrors({ api: "Failed to upload files. Please try again." });
          }
        } else if (message === "Survey successfully saved") {
          setFormSuccessData(result);
          navigate("/success");
          window.scrollTo(0, 0);
        } else {
          setErrors({ api: "Failed to save survey. Please try again later." });
        }
      } catch (error) {
        console.error("Error during API submission:", error);
        setErrors({ api: "An error occurred during submission. Please try again." });
      } finally {
        setLoading(false);
      }
    } else {
      console.log("Validation failed. Please check errors.");
      setLoading(false); 
    }
  };
  const handleRadioChange = (index, choiceValue, choiceIndex) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [`question-${index}-options`]: choiceValue,
      };
  
      questions.forEach((question, questionIndex) => {
        if (question.isDependent && question.parentQuestionId === questions[index].questionId) {
          if (choiceValue === "No") {
            updatedData[`question-${questionIndex}-options`] = "";
          } else {
            updatedData[`question-${questionIndex}-options`] =
              prevData[`question-${questionIndex}-options`] || "";
          }
        }
      });
  
      return updatedData;
    });
  };
  
  const handleUnibankerChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      unibanker: value,
    }));
  };
  const validateStep1 = () => {
    const newErrors = {};
  
    console.log("Form Data inside validateStep1:", formData);
  
    if (!formData.email) {
      newErrors.email = "This field is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!formData.firstName) {
      newErrors.firstName = "This field is required.";
    } else if (!/^[A-Za-z\s]+$/.test(formData.firstName)) {
      newErrors.firstName = "Only letters are allowed in the first name.";
    }
    if (!formData.lastName) {
      newErrors.lastName = "This field is required.";
    } else if (!/^[A-Za-z\s]+$/.test(formData.lastName)) {
      newErrors.lastName = "Only letters are allowed in the last name.";
    }
    if (!formData.branch) {
      newErrors.branch = "This field is required.";
    } else if (!/^[A-Za-z\s]+$/.test(formData.branch)) {
      newErrors.branch = "Only letters are allowed in the branch field.";
    }
    
    if (!formData.referrer) {
      newErrors.referrer = "This field is required.";
    } else if (!/^[A-Za-z\s]+$/.test(formData.referrer)) {
      newErrors.referrer = "Only letters are allowed in the referrer field.";
    }
    if (!formData.mobileNumber) {
      newErrors.mobileNumber = "This field is required.";
    } else if (/^\d+$/.test(formData.mobileNumber)) {
      if (formData.mobileNumber.length !== 11) {
        newErrors.mobileNumber = "Mobile number must be exactly 11 digits.";
      }
    } else if (!/^[a-zA-Z]+$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Only letters are allowed for alphabetic input.";
    }
    
    
    
    if (formData.unibanker === "yes") {
      if (!formData.employeeNumber) {
        newErrors.employeeNumber = "This field is required.";
      } else if (!/^\d+$/.test(formData.employeeNumber)) {
        newErrors.employeeNumber = "Only numeric values are allowed in the employee number field.";
      } else if (!/^\d{10}$/.test(formData.employeeNumber)) {
        newErrors.employeeNumber = "The employee number must be exactly 10 digits.";
      }
    }    
  
    if (!formData.unibanker) {
      newErrors.options = "Please select an option for BPI/MS Insurance.";
    }
  
    if (!formData.agreeField) {
      newErrors.agreeField = "You must agree to the terms and conditions.";
    }
  
    setErrors(newErrors);
  
    const isValid = Object.keys(newErrors).length === 0;
    console.log("Form 1 validity:", isValid);
    return isValid;
  };
  
  const validateStep2 = () => {
    const questionAnswers = {};
    const newErrors = {};
    let isValid = true;
  
    questions.forEach((question, index) => {
      const optionValue = formData[`question-${index}-options`];
      const inputIdOrName = `question-${index}-options`;
  
      const isEmpty = optionValue === undefined || optionValue === null ||
                      (typeof optionValue === 'string' && optionValue.trim() === "");
  
      if (question.isRequired === 1 && isEmpty) {
        newErrors[inputIdOrName] = "This field is required.";
        isValid = false;
      } else {
        const stringOptionValue = String(optionValue);
  
        if (question.questionType === "Text") {
          const previousQuestion = questions[index - 1];
          const isRequired = question.isRequired === 1;
          const isDependent = question.isDependent === 0;
          if (isRequired) {
            if (
              previousQuestion &&
              previousQuestion.questionType === "Single Choice" &&
              formData[`question-${index - 1}-options`] === "Yes" &&
              (!stringOptionValue || stringOptionValue.trim() === "")
            ) {
              newErrors[inputIdOrName] = "This field is required when the previous question is answered 'Yes'.";
              isValid = false;
            } else if (!stringOptionValue || stringOptionValue.trim() === "") {
              newErrors[inputIdOrName] = "This field is required.";
              isValid = false;
            } else if (/[^a-zA-Z0-9\s]/.test(stringOptionValue)) {
              newErrors[inputIdOrName] = "Only letters, numbers, and spaces are allowed.";
              isValid = false;
            }
          }
        }
  
        if (question.questionType === "Multiple Choice" && (!optionValue || optionValue.length === 0)) {
          newErrors[inputIdOrName] = "At least one option must be selected.";
          isValid = false;
        }
  
        if (question.questionType === "Single Choice" && !optionValue) {
          newErrors[inputIdOrName] = "This field is required.";
          isValid = false;
        }
      }
  
      questionAnswers[question.questionId] = optionValue || "";
    });
  
    if (files.length === 0) {
      newErrors.files = "At least one file must be uploaded.";
      isValid = false;
    } else if (files.length > 5) {
      newErrors.files = "You can upload a maximum of 5 files.";
      isValid = false;
    } else {
      files.forEach((file) => {
        const fileType = file.type.toLowerCase();
        const validTypes = ["application/pdf", "image/png", "image/jpg", "image/jpeg"];
        if (!validTypes.includes(fileType)) {
          newErrors.files = "Only PDF, PNG, JPG, and JPEG files are allowed.";
          isValid = false;
        }
        if (file.size > 10 * 1024 * 1024) {
          newErrors.files = "Each file must not exceed 10 MB.";
          isValid = false;
        }
      });
    }
  
    setErrors(newErrors);
    return isValid;
  };
  
  const handleCheckboxChange = (index, value) => {
    setFormData((prevData) => {
      const currentChoices = prevData[`question-${index}-options`] || [];
  
      if (currentChoices.includes(value)) {
        return {
          ...prevData,
          [`question-${index}-options`]: currentChoices.filter((item) => item !== value),
        };
      } 
      else {
        return {
          ...prevData,
          [`question-${index}-options`]: [...currentChoices, value],
        };
      }
    });
  };
  
  const handleNext = () => {
    if (currentStep === 1 && !validateStep1()) return;
    if (currentStep === 2 && !validateStep2()) return;
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    nextStep();
  };

  const renderFormStep = () => {
    if (currentStep === 1) {
      return (
        <div>
          <div className="p-6 bg-white rounded shadow-lg mb-4">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleEmailChange}
                className={`w-full sm:w-1/2 p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } focus:ring-blue-400 focus:border-blue-400`}
                placeholder="Your email"
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-sm">{errors.email}</span>
            )}
          </div>

          <div className="p-6 bg-white rounded shadow-md">
            <h2 className="text-lg font-bold mb-4">Personal Information</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  What is your First Name?{" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                    errors.firstName ? "border-red-500" : "border-gray-300"
                  } focus:ring-blue-400 focus:border-blue-400`}
                  disabled={!formData.email}
                />
                {errors.firstName && (
                  <span className="text-red-500 text-sm">
                    {errors.firstName}
                  </span>
                )}
              </div>
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  What is your Last Name? <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                    errors.lastName ? "border-red-500" : "border-gray-300"
                  } focus:ring-blue-400 focus:border-blue-400"
                  } focus:ring-blue-400 focus:border-blue-400`}
                  disabled={!formData.email}
                />
                {errors.lastName && (
                  <span className="text-red-500 text-sm">
                    {errors.lastName}
                  </span>
                )}
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-700 mb-2">
                Are you a BPI Unibanker? If Yes, Please input your 10-digit employee number <span className="text-red-500">*</span>
              </label>
              <div className="flex flex-col text-sm font-bold space-y-2">
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="unibanker"
                    value="yes"
                    id="isUnibankerY"
                    className="border-gray-300 text-blue-600"
                    onChange={() => handleUnibankerChange("yes")}
                    checked={formData.unibanker === "yes"}
                    disabled={!formData.email}
                  />
                  <span>Yes</span>
                </label>
                <label className="flex items-center text-sm font-bold space-x-2">
                <input
                      type="radio"
                      name="unibanker"
                      value="no"
                      id="isUnibankerN"
                      className="border-gray-300 text-blue-600"
                      onChange={() => handleUnibankerChange("no")}
                      checked={formData.unibanker === "no"}
                      disabled={!formData.email}
                    />
                  <span>No</span>
                </label>
              </div>
              {errors.options && <span className="text-red-500 text-sm">{errors.options}</span>}
              
              {formData.unibanker === "yes" && (
                <div className="mt-4">
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Employee Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="employeeNumber"
                    value={formData.employeeNumber}
                    onChange={handleChange}
                    maxLength={10}
                    className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                      errors.employeeNumber ? "border-red-500" : "border-gray-300"
                    } focus:ring-blue-400 focus:border-blue-400`}
                    placeholder="Enter your 10-digit employee number"
                    disabled={!formData.email}
                  />
                  {errors.employeeNumber && <span className="text-red-500 text-sm">{errors.employeeNumber}</span>}
                </div>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-700 mb-2">
                What is your BPI Branch ? / Who is your Referring Branch ? <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="branch"
                value={formData.branch}
                onChange={handleChange}
                className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                  errors.firstname ? "border-red-500" : "border-gray-300"
                } focus:ring-blue-400 focus:border-blue-400`}
                disabled={!formData.email}
              />
              {errors.branch && (
                <span className="text-red-500 text-sm">{errors.branch}</span>
              )}
            </div>
            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-700 mb-2">
                Who referred you ? (BPI Personnel) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="referrer"
                value={formData.referrer}
                onChange={handleChange}
                className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                  errors.firstname ? "border-red-500" : "border-gray-300"
                } focus:ring-blue-400 focus:border-blue-400`}
                disabled={!formData.email}
              />
              {errors.referrer && (
                <span className="text-red-500 text-sm">{errors.referrer}</span>
              )}
            </div>
            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-700 mb-2">
                May we reach out to you via SMS or phone call? Please provide
                your valid mobile number. <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                className={`w-full p-2 text-sm text-gray-800 bg-[#F0F8FF] border border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 ${
                  errors.firstname ? "border-red-500" : "border-gray-300"
                } focus:ring-blue-400 focus:border-blue-400`}
                disabled={!formData.email}
              />
              {errors.mobileNumber && (
                <span className="text-red-500 text-sm">
                  {errors.mobileNumber}
                </span>
              )}
            </div>
          </div>
        </div>
      );
    } else if (currentStep === 2) {
      return (
        <div>
          <div className="p-6 bg-white rounded shadow-lg mb-4">
            <h2 className="text-lg font-bold mb-4">
              {survey.title || "QUICK CAR INSURANCE SURVEY"}
            </h2>
      
            {questions
              .sort((a, b) => a.seqNo - b.seqNo)
              .map((question, index) => {
                const isDependentQuestion = question.isDependent && question.parentQuestionId;
                
                const shouldShowDependentQuestion = !isDependentQuestion || (
                  isDependentQuestion && 
                  formData[`question-${questions.findIndex(q => q.questionId === question.parentQuestionId)}-options`] === "Yes"
                );
      
                return shouldShowDependentQuestion ? (
                  <div className="mb-4" key={question.questionId}>
                    <label
                      htmlFor={`question-${index}`}
                      className="block text-sm font-bold text-gray-700 mb-2"
                    >
                    {question.questionValue}
                    {question.isRequired === 1 && <span className="text-red-500"> *</span>}
                    </label>
      
                    <input type="hidden" name={`surveyId-${index}`} value={question.surveyId} />
      
                    {question.questionType === "Single Choice" && (
                      <div>
                        <ul className="list-none">
                          {["Yes", "No"].map((choiceValue, idx) => (
                            <li key={`${question.questionId}-choice-${idx}`} className="flex items-center gap-2 my-2">
                              <label className="flex items-center gap-2 text-sm text-gray-700">
                                <input
                                  type="radio"
                                  name={`question-${index}-options`}
                                  value={choiceValue}
                                  checked={formData[`question-${index}-options`] === choiceValue}
                                  onChange={() => handleRadioChange(index, choiceValue, idx)}
                                  className="w-4 h-4 bg-[#F0F8FF] border-2 border-[#B9B9B9] rounded-[5px]"
                                />
                                {choiceValue}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {errors[`question-${index}-options`] && (
                          <p className="text-red-500 text-xs">{errors[`question-${index}-options`]}</p>
                        )}
                      </div>
                    )}
      
                    {question.questionType === "Multiple Choice" && (
                      <div>
                        <ul className="list-none">
                          {choices
                            .filter((choice) => choice.questionId === question.questionId)
                            .map((choice) => (
                              <li key={choice.choiceId} className="flex items-center gap-2 my-2">
                                <label className="flex items-center gap-2 text-sm text-gray-700">
                                  <input
                                    type="checkbox"
                                    name={`question-${index}-options`}
                                    value={choice.choiceValue}
                                    checked={formData[`question-${index}-options`]?.includes(choice.choiceValue)}
                                    onChange={() => handleCheckboxChange(index, choice.choiceValue, choice.choiceId)}
                                    className="w-4 h-4 bg-[#F0F8FF] border-2 border-[#B9B9B9] rounded-[5px]"
                                  />
                                  {choice.choiceValue}
                                </label>
                              </li>
                            ))}
                        </ul>
                        {errors[`question-${index}-options`] && (
                          <p className="text-red-500 text-xs">{errors[`question-${index}-options`]}</p>
                        )}
                      </div>
                    )}
      
                    {question.questionType === "Text" && (
                      <div>
                        <input
                          id={`question-${index}`}
                          name={`question-${index}-answer`}
                          placeholder="Enter your answer here"
                          className={`w-full px-3 py-2 border ${errors[`question-${index}-options`] ? "border-red-500" : "border-gray-300"} rounded-md focus:outline-none focus:ring focus:ring-blue-200`}
                          value={formData[`question-${index}-options`] || ""}
                          onChange={(e) =>
                            setFormData((prevData) => ({
                              ...prevData,
                              [`question-${index}-options`]: e.target.value,
                            }))
                          }
                        />
                        {errors[`question-${index}-options`] && (
                          <p className="text-red-500 text-xs">{errors[`question-${index}-options`]}</p>
                        )}
                      </div>
                    )}
                  </div>
                ) : null;
              })}
      
            <div className="mb-4">
              <label htmlFor="file-upload" className="block text-sm font-bold text-gray-700 mb-2">
                Upload your car insurance policy/ies <span className="text-red-500">*</span>
              </label>
              <p className="text-xs text-gray-600 mb-2">Supported: PDF, PNG, JPG. Max 10 MBUpload up to 5 supported files: PDF, drawing, or image. Max 10 MB per file.
              Add file.</p>
              <div className="mb-4">
                {files.map((file, index) => (
                  <div key={index} className="flex items-center bg-[#F0F8FF] border px-3 py-1 rounded mb-2">
                    <span className="text-sm text-gray-700">{file.name}</span>
                    <button onClick={() => removeFile(index)} className="text-red-500 text-xs ml-auto">
                      <IoIosRemoveCircleOutline />
                    </button>
                  </div>
                ))}
              </div>
      
              {files.length < 5 && (
                <>
                  <input
                    id="file-upload"
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    className="hidden"
                    onChange={handleFileChange}
                    multiple
                  />
                  <label
                    htmlFor="file-upload"
                    className="bg-[#F0F8FF] border rounded px-3 py-2 text-blue-700 cursor-pointer"
                  >
                    <img src={uploadIcon} alt="Upload Icon" className="inline-block h-4 w-4 mr-2" />
                    Add a file
                  </label>
                </>
              )}
              {errors.files && <p className="text-red-500 text-xs mt-3">{errors.files}</p>}
            </div>
          </div>
        </div>
      );
      
    }
  };

  return (
    <div className="relative min-h-screen">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
        }}
      ></div>
      <div
        className="absolute inset-0 bg-black"
        style={{
          height: "100vh",
          opacity: 0.42,
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      ></div>

      <div className="relative z-10 min-h-screen flex flex-col items-center">
        <h1 className="text-3xl text-center md:text-5xl uppercase font-bold text-white mt-32 mb-6">
          Helping to Protect Hard-Earned Assets
        </h1>
        {loading && <Preloader />}
        <form className="w-full md:w-auto">
        <div className="p-4 bg-white rounded-lg shadow-lg mb-4 w-full">
        <h2 className="text-xl md:text-3xl font-bold text-gray-800">
          BPI MS Quick Survey
        </h2>
        <p className="text-lg text-lg text-gray-600 mt-2">
          Share your feedback on how BPI MS can improve its product and services
          and receive a free e-gift certificate (eGC)!
        </p>
        <div className="border-t border-dashed border-gray-400 my-4"></div>
        <p className="text-lg text-lg text-gray-600 mt-2">
          Only those who have completed the survey with a copy of a valid
          non-BPI MS motor insurance policy will be entitled to receive the free
          e-gift <br /> certificate (eGC).
        </p>
        <p className="text-lg text-lg text-gray-600 mt-2">
          Information collected will be processed by BPI and BPI MS for the
          release of the eGC and to offer you products and services that <br /> you
          might find interesting and useful. The full Privacy Policies can be
          found at{" "}
          <a
            href="https://www.bpi.com.ph"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            www.bpi.com.ph
          </a>{" "}
          and{" "}
          <a
            href="https://www.bpims.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            www.bpims.com
          </a>
          .
        </p>

          <div className="my-3">
            <div className="flex flex-col items-start gap-2">
              <div className="flex items-center gap-2">
                <label htmlFor="agreeField" className="text-lg text-gray-700">
                <input
                  id="agreeField"
                  type="checkbox"
                  className="w-3 h-3 bg-[#F0F8FF] border-2 border-[#B9B9B9] rounded-[5px] focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                  checked={formData.agreeField || false} 
                  onChange={(e) =>
                    setFormData({ ...formData, agreeField: e.target.checked })
                  }
                />{" "}
                  I have read, understood and agree to the{" "}
                  <a href="https://tinyurl.com/3hn7fnhp"
                      target="_blank"
                      rel="noopener noreferrer"><span className="font-bold">BPI MS Customer Charter</span></a> of
                  this microsite, the{" "}
                  
                  <a
                    href="https://tinyurl.com/ysptmfya"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-bold"
                  >
                    BPI MS Privacy Policy
                  </a>.
                </label>
              </div>
            </div>
            {errors.agreeField && (
              <span className="text-red-500 text-sm">{errors.agreeField}</span>
            )}
          </div>
        </div>
          <div className="mt-4">{renderFormStep()}</div>
          <div className="flex items-center justify-center mt-6 space-x-4">
          <button
              type="button"
              onClick={() => {
                prevStep();
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
              }}
              disabled={currentStep === 1}
              className={`px-4 py-2 bg-[#2563EB] rounded ${
                currentStep === 1
                  ? "border-gray-400 text-gray-400"
                  : "border-white text-white"
              }`}
            >
              Previous
            </button>

            <span className="text-blue-600">
              Page {currentStep} of {totalSteps}
            </span>
            <button
              type="button"
              onClick={currentStep === 2 ? handleSubmit : handleNext}
              className={`px-4 py-2 bg-[#2563EB] rounded ${
                currentStep === totalSteps
                  ? "border-white text-white"
                  : "border-white text-white"
              }`}
            >
              {currentStep === 2 ? "Submit" : "Next"}
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Survey;
